var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 20.2285H19.625V21.4368H12.375V20.2285Z",
    fill: "#D1D6D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2292 14.791C21.2303 14.791 22.0417 13.9795 22.0417 12.9785C22.0417 11.9775 21.2303 11.166 20.2292 11.166C19.2282 11.166 18.4167 11.9775 18.4167 12.9785C18.4167 13.9795 19.2282 14.791 20.2292 14.791Z",
    fill: "#D1D6D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7708 14.791C12.7718 14.791 13.5833 13.9795 13.5833 12.9785C13.5833 11.9775 12.7718 11.166 11.7708 11.166C10.7697 11.166 9.95825 11.9775 9.95825 12.9785C9.95825 13.9795 10.7697 14.791 11.7708 14.791Z",
    fill: "#D1D6D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.988 3.91602C9.318 3.91602 3.91675 9.32935 3.91675 15.9993C3.91675 22.6693 9.318 28.0827 15.988 28.0827C22.6701 28.0827 28.0834 22.6693 28.0834 15.9993C28.0834 9.32935 22.6701 3.91602 15.988 3.91602ZM16.0001 25.666C10.6592 25.666 6.33341 21.3402 6.33341 15.9993C6.33341 10.6585 10.6592 6.33268 16.0001 6.33268C21.3409 6.33268 25.6667 10.6585 25.6667 15.9993C25.6667 21.3402 21.3409 25.666 16.0001 25.666Z",
    fill: "#D1D6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.b48407e2e96cb628b197a25a355fbfd4.svg";
export { ForwardRef as ReactComponent };